var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepArrow2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 32.007,
    viewBox: "0 0 98 32.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18723",
    "data-name": "Group 18723",
    transform: "translate(-498 -1575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18722",
    "data-name": "Group 18722",
    transform: "translate(11 19.609)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17320",
    "data-name": "Rectangle 17320",
    width: 98,
    height: 23,
    transform: "translate(487 1560)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25857",
    "data-name": "Path 25857",
    d: "M0,92.95c9.562-4.074,22.308-26.065,24.628-41.738,2.512-16.965.405-26.681-10.253-46.593,1.511.295,2.685.573,3.878.744a25.714,25.714,0,0,0,3.927.351A1.572,1.572,0,0,0,23.311,4.7a1.462,1.462,0,0,0-.842-1.2C18.844,2.315,15.189,1.2,11.522.128A1.747,1.747,0,0,0,9.06,1.34c-1.218,4.327-2.5,8.641-3.611,12.989a13.675,13.675,0,0,0,.093,3.549C8.753,16.793,8.388,14.4,9.249,12.7a62.693,62.693,0,0,0,2.322-6.045,49.782,49.782,0,0,1,8.563,16.99C26.29,45.306,21.217,65.188,7.463,83.605c-1.791,2.4-3.9,4.612-5.823,6.934C1.12,91.167.725,91.875,0,92.95",
    transform: "matrix(0.07, 0.998, -0.998, 0.07, 591.902, 1575.001)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepArrow2);
export default __webpack_public_path__ + "static/media/step-arrow-2.a65b73f200d013bf173cdd50f891d324.svg";
export { ForwardRef as ReactComponent };